import React, { useEffect, useState } from "react";
import SEO from "../common/SEO";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ContactLocation from "../component/contact/ContactLocation";
import SectionTitle1 from "../elements/section-title/SectionTitle1";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientSlider from "../component/client/ClientSlider";
import { useLocation } from "react-router-dom";
import ContactForm from "../component/contact/ContactForm";

const Contact = () => {
  const location = useLocation();
  const [isTabletOrBelow, setIsTabletOrBelow] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrBelow(window.innerWidth <= 1024); // Tablet and below
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          setTimeout(() => {
            const yOffset = -100; // Adjust this offset to match your fixed header height
            const y =
              element.getBoundingClientRect().top +
              window.pageYOffset +
              yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
          }, 100); // Delay ensures the DOM is ready
        }
      }
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => {
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, [location]);

  return (
    <>
      <SEO title="Contact Us" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          subtitle="Get in touch with our team to discover how we can help your business."
          title="Contact Our Experts Today"
          page="Contact-us"
        />

        <div className="section section-padding">
          <div className="container">
            <div className="row">
              <div className="col-xl-5 col-lg-6">
                <div className="contact-form-box shadow-box mb--30">
                  <h3 className="title">Get Free Quote Now</h3>
                  <ContactForm />
                </div>
              </div>
              <div className="col-xl-5 col-lg-6 offset-xl-1" id="contact">
                <div className="contact-info mb--100 mb_md--30 mt_md--0 ">
                  <h4 className="title">
                    Reach Out to Us For Immediate Assistance
                  </h4>
                  <p>
                    Are you a client in need of urgent support? Please get in
                    touch with us at our toll-free number:{" "}
                  </p>
                  <h4
                    className="phone-number"
                    style={{ fontSize: isTabletOrBelow ? "17px" : "48px" }}
                  >
                    <a href="tel:800-8293">
                      800-8293 {!isTabletOrBelow && <br />}
                      (800 UCWF),{" "}
                    </a>
                  </h4>
                  <h4
                    className="phone-number"
                    style={{ fontSize: isTabletOrBelow ? "17px" : "48px" }}
                  >
                    <a href="tel:+971 44357619">+971 44357619</a>
                  </h4>
                </div>
                <div className="contact-info mb--30">
                  <h4 className="title">Email Support</h4>
                  <p>Send us your questions, feedback, or requests at:</p>
                  <h4
                    className="phone-number"
                    style={{ fontSize: isTabletOrBelow ? "17px" : "48px" }}
                  >
                    <a href="mailto:info@ucwf.net">info@ucwf.net</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="section section-padding bg-color-dark overflow-hidden"
          id="location"
        >
          <div className="container">
            <SectionTitle1
              subtitle="Find Us"
              title="Our office"
              description="Office No. 905, 9th Floor Prism Tower, Happiness Street Business Bay PO Box 124377, Dubai, UAE"
              textAlignment="heading-light-left"
              textColor=""
            />
            <div className="row justify-content-center">
              <ContactLocation />
            </div>
          </div>
        </div>
        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default Contact;
